import { type FC } from "react";
import { Button } from "@root/shared/components/Button";
import { Link } from "@root/shared/components/Link";
import { type SubmitButtonsProps } from "@clientFrontend/features/entry/components/NotAdopted/type";
import * as styles from "./styles.css";

export const SubmitButtons: FC<SubmitButtonsProps> = ({
  returnPagePath,
  gaLabel,
  isApp,
  isLoading,
}) => {
  return (
    <div className={styles.submitBox}>
      {!isApp && (
        <Link theme="tertiary" href={returnPagePath} className={styles.button}>
          キャンセル
        </Link>
      )}
      <Button
        theme="primary"
        form="form"
        type="submit"
        disabled={isLoading}
        className={styles.button}
        data-ga-action="job_entry_not_adopted_confirm"
        data-ga-label={gaLabel}
      >
        不採用を確定する
      </Button>
    </div>
  );
};
